import React, { useState } from 'react';
import ReactDom from 'react-dom';
import './holidaySelectionModal.scss';

interface IHolidayModal {
    setShowFunc?: any;
    header: string;
    description: string;
    buttonText: string;
}
interface IHoliday {
    setShowFunc?: any;
    header: string;
    description: string;
    buttonText: string;
    title: string;
}

const HolidayModal = ({ setShowFunc, header, description, buttonText }: IHolidayModal) => {
    return ReactDom.createPortal(
        <>
            <div className="HolidaySelectionModalOverlayStyles">
                <div className="HolidaySelectionModalStyles">
                    <div className="header">{header}</div>
                    <div className="description">{description}</div>
                    <div className="buttonRow">
                        <button
                            onClick={() => {
                                setShowFunc(false);
                            }}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById('modalPortal')!,
    );
};

const HolidaySelectionModal = ({ setShowFunc, header, description, buttonText, title }: IHoliday) => {
    const [show, setShow] = useState<boolean>(false);

    return (
        <div className="HolidaySelectionModal">
            <div
                onClick={() => {
                    setShow(!show);
                }}
            >
                {title}
            </div>

            {show ? (
                <HolidayModal setShowFunc={setShow} header={header} description={description} buttonText={buttonText} />
            ) : (
                <></>
            )}
        </div>
    );
};

export default HolidaySelectionModal;
